import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconSave = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M31.573 1.92c-.586.122-1.1.541-1.375 1.12l-.182.384v16.528c0 9.09-.021 16.528-.047 16.528s-1.862-1.813-4.08-4.03c-4.48-4.475-4.276-4.304-5.125-4.304a1.98 1.98 0 0 0-1.83 2.8c.12.272 1.075 1.255 6.076 6.25 5.73 5.722 5.947 5.93 6.318 6.067a2.06 2.06 0 0 0 1.543-.066c.458-.22 11.96-11.72 12.188-12.189.131-.267.157-.415.157-.896 0-.519-.019-.61-.19-.919a2.18 2.18 0 0 0-.907-.873c-.544-.258-1.348-.23-1.847.065-.14.083-2.041 1.938-4.224 4.123-2.182 2.185-3.99 3.972-4.016 3.972s-.048-7.425-.048-16.5c0-18.589.052-16.822-.517-17.446a2.02 2.02 0 0 0-1.894-.614M15.52 11.36c-4.236.672-7.527 4.151-7.965 8.42-.093.903-.093 32.88 0 33.798a9.47 9.47 0 0 0 6.717 8.139c1.397.42.335.396 17.728.396s16.331.024 17.728-.396a9.47 9.47 0 0 0 6.717-8.139c.093-.917.093-32.895 0-33.799-.333-3.248-2.316-6.089-5.289-7.578-.798-.4-1.985-.752-2.932-.872-.385-.048-1.709-.066-4-.052l-3.424.02-.308.158c-.379.193-.779.616-.959 1.015-.099.22-.135.427-.134.779 0 .637.18 1.046.64 1.467.572.523.528.517 3.86.517 3.969 0 4.542.066 5.637.651 1.55.828 2.624 2.316 2.879 3.989.047.311.063 5.527.05 17.12-.019 15.914-.025 16.69-.136 17.056-.311 1.025-.827 1.848-1.627 2.597-.81.758-1.664 1.194-2.688 1.372-.818.143-31.21.143-32.027 0-1.025-.178-1.878-.614-2.688-1.372-.816-.763-1.341-1.61-1.63-2.629-.112-.4-.117-1.103-.117-17.312V19.808l.148-.512c.515-1.784 1.893-3.226 3.61-3.775.745-.238 1.59-.289 4.79-.289 3.333 0 3.29.006 3.862-.518.46-.42.638-.83.638-1.466 0-.8-.386-1.426-1.112-1.803l-.288-.149-3.584-.01c-2.627-.006-3.72.013-4.096.072" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconSave.displayName = 'IconSave';